import { useCallback, useMemo } from "react";
import useApi from "../hooks/useApi";

export const useSensorReadingService = () => {
  const { get } = useApi();

  const getSensorReadings = useCallback(async () => {
    return await get(`/sensor-readings`);
  }, [get]);

  return useMemo(
    () => ({
      getSensorReadings,
    }),
    [getSensorReadings]
  );
};
